"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _axios = _interopRequireDefault(require("axios"));

var _constant = require("../constant");

var _index = require("./index");

var _constant2 = require("./constant");

var useFetch = function useFetch(requestObject, key) {
  var _useState = (0, _react.useState)(requestObject),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      nData = _useState2[0],
      setNData = _useState2[1];

  var _useContext = (0, _react.useContext)(_index.Context),
      store = _useContext.store,
      dispatch = _useContext.dispatch;

  (0, _react.useEffect)(function () {
    var fetchData = function fetchData() {
      dispatch({
        type: _constant2.ACTION_CONSTANTS.DATA_FETCH_START,
        payload: {
          key: key
        }
      });

      if (nData.method === _constant.HTTPS_METHOD.POST) {
        return _axios.default.post(nData.url, nData.payload, {
          headers: nData.headers
        }).then(function (json) {
          dispatch({
            type: _constant2.ACTION_CONSTANTS.DATA_FETCH_SUCCESS,
            payload: {
              key: key,
              json: json
            }
          });
        }).catch(function () {
          dispatch({
            type: _constant2.ACTION_CONSTANTS.DATA_FETCH_FAILURE,
            payload: {
              key: key
            }
          });
        });
      }

      if (nData.method === _constant.HTTPS_METHOD.GET) {
        return _axios.default.get(nData.url, {
          headers: nData.headers
        }).then(function (json) {
          dispatch({
            type: _constant2.ACTION_CONSTANTS.DATA_FETCH_SUCCESS,
            payload: {
              key: key,
              json: json
            }
          });
        }).catch(function () {
          dispatch({
            type: _constant2.ACTION_CONSTANTS.DATA_FETCH_FAILURE,
            payload: {
              key: key
            }
          });
        });
      }

      return null;
    }; // eslint-disable-next-line no-unused-expressions


    nData && fetchData();
  }, [nData, key, dispatch]);
  return [store[key], setNData];
};

var _default = useFetch;
exports.default = _default;